import React from 'react';

import ProgressTrackerLib, { ProgressTrackerStep } from '@amzn/meridian/progress-tracker';
import { useAppSelector } from 'src/store/store';

const PROGRESS_TRACKER_STEPS = [
  { label: 'Background', progressTrackerValue: 0 },
  { label: 'Restrictions', progressTrackerValue: 1 },
  { label: 'Job Matches', progressTrackerValue: 2 },
  { label: 'Review', progressTrackerValue: 3 },
  { label: 'Send for Approval', progressTrackerValue: 4 },
] as const;

/**
 * Main component for the progress tracker.
 * @returns
 */
const ProgressTracker = () => {
  const { pageProgress } = useAppSelector((state) => state.newJmrPage);
  return (
    <div className="progress-tracker">
      <ProgressTrackerLib compact={true} direction="row">
        {PROGRESS_TRACKER_STEPS.map((step, index) => (
          <ProgressTrackerStep
            key={index}
            type={getProgressTrackerType(pageProgress, step.progressTrackerValue)}
            label={step.label}
            showLabel={true}
          />
        ))}
      </ProgressTrackerLib>
    </div>
  );
};

/**
 * Get the type of progress "past/present/future".
 */
const getProgressTrackerType = (pageProgress: number, step: number) => {
  return pageProgress === step ? 'present' : pageProgress < step ? 'future' : 'past';
};

export default ProgressTracker;
